import React from "react";
import styled from "@emotion/styled";
import { Box, Heading, Text, TouchableOpacity, Flex, TextUppercase } from "@atoms";
import { CollectionRenderFragment } from "../CollectionRender/__generated__/CollectionRenderFragment";
import { Link } from "@reach/router";
import { RailsUrl } from "@services";
import { useStoreAppValue } from "@hooks";

// == Types ================================================================

interface IProps {
  collection: CollectionRenderFragment;
  onGetCurrentPosition: () => void;
  loading: boolean;
}

// == Constants ============================================================

// == Component ============================================================

// == Component ============================================================

const CollectionNearbyBrandsTitle = ({ loading, collection, onGetCurrentPosition }: IProps) => {
  const { campaignId } = useStoreAppValue();

  const renderFindMeButton = () => {
    return (
      <TouchableOpacity onTouch={onGetCurrentPosition}>
        <Box>
          <Text fontSize={[0, 1]}>{loading ? "Updating..." : "Update My Location"}</Text>
        </Box>
      </TouchableOpacity>
    );
  };

  return (
    <Flex mb={2} justifyContent="space-between">
      {!!collection.name && (
        <Flex width="80%">
          <Box maxWidth="55%" mr={2}>
            <Heading ellipsis fontSize={[2, 3]}>
              {collection.name}
            </Heading>
          </Box>
          {renderFindMeButton()}
        </Flex>
      )}
      <Box>
        <Link to={RailsUrl.nearbyUrl({ campaignId })}>
          <TextUppercase fontSize={[0, 1]}>View All</TextUppercase>
        </Link>
      </Box>
    </Flex>
  );
};

export default CollectionNearbyBrandsTitle;

// == Styles ===============================================================
